import React, { Dispatch, SetStateAction } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Form } from "../interfaces";

interface Props {
  label: string;
  fieldName: string;
  currentValue: boolean | undefined;
  form: Form;
  setForm: Dispatch<SetStateAction<any>>;
  disabled?: boolean;
}

export default function IncludeCheckbox({
  label,
  fieldName,
  currentValue,
  form,
  setForm,
  disabled,
}: Props) {
  const [check, setCheck] = React.useState<boolean>(
    !currentValue ? false : currentValue,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheck(event.target.checked);
    setForm({ ...form, [fieldName]: !check });
  };
  return (
    <FormControlLabel
      slotProps={{ typography: { sx: { color: "primary.main" } } }}
      control={
        <Checkbox
          id={fieldName}
          disabled={disabled}
          sx={{
            "&.Mui-focusVisible": {
              backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
          }}
          aria-label={label}
          color="primary"
          disableFocusRipple
          checked={check}
          onChange={handleChange}
          name={label}
        />
      }
      label={label}
    />
  );
}
